// extracted by mini-css-extract-plugin
export var skipAnimation = "_11-0";